import * as React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import MediaQuery from 'react-responsive';
import { MOBILE_MIN_WIDTH } from '../../../utils';
const ServicesGroup = props => {
    const theme = useTheme('ServiceAggregation').ServicesGroup;
    return (React.createElement("div", { className: cn(theme.group, props.className) },
        React.createElement("div", { className: theme.group__description },
            React.createElement("div", { className: theme.timeline },
                React.createElement("div", { className: theme.icon }, props.icon),
                React.createElement("div", null,
                    React.createElement("div", { className: theme.direction }, props.directionLabel),
                    React.createElement("div", { className: theme.time }, props.timePeriod))),
            !props.empty && (React.createElement(MediaQuery, { minWidth: MOBILE_MIN_WIDTH },
                React.createElement("div", { className: theme.description }, props.description)))),
        !props.empty && React.createElement("div", { className: theme.services }, props.children),
        props.empty && React.createElement("div", { className: theme.empty }, props.description)));
};
export default ServicesGroup;
